import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Output, inject, signal } from '@angular/core';
import {
	AbstractControl,
	FormBuilder,
	FormGroup,
	ReactiveFormsModule,
	ValidationErrors,
	ValidatorFn,
	Validators
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormErrorsPipe } from '../../../../shared/utils/pipes/form-errors.pipe';
import { LucideAngularModule } from 'lucide-angular';

const emailsMatchValidator: ValidatorFn = (
	group: AbstractControl
): ValidationErrors | null => {
	const email = group.get('email')?.value;
	const confirmEmail = group.get('confirmEmail')?.value;
	return email && confirmEmail && email !== confirmEmail
		? { emailsMismatch: true }
		: null;
};

@Component({
	selector: 'app-register-access',
	standalone: true,
	imports: [
		CommonModule,
		ReactiveFormsModule,
		MatCardModule,
		MatFormFieldModule,
		MatInputModule,
		MatButtonModule,
		MatCheckboxModule,
		LucideAngularModule,
		FormErrorsPipe
	],
	templateUrl: './register_access.html',
	styleUrl: './register_access.scss'
})
export class RegisterAccessComponent {
	@Output() accessDataChange = new EventEmitter<{ email: string }>();
	@Output() submitRegister = new EventEmitter<void>();

	private fb = inject(FormBuilder);

	accessForm: FormGroup = this.fb.group(
		{
			email: ['', [Validators.required, Validators.email]],
			confirmEmail: ['', [Validators.required, Validators.email]],
			celular: [
				'',
				[Validators.required, Validators.minLength(10), Validators.pattern(/^\+?\d+$/)]
			],
			telefono: ['', [Validators.pattern(/^\+?\d+$/)]],
			terminosAceptados: [false, Validators.requiredTrue]
		},
		{ validators: emailsMatchValidator }
	);

	loading = signal(false);
	errorMessage = signal<string | null>(null);

	get emailsMismatch(): boolean {
		return (
			this.accessForm.hasError('emailsMismatch') &&
			(this.accessForm.get('confirmEmail')?.touched ?? false)
		);
	}

	submit(): void {
		if (this.accessForm.invalid) {
			this.accessForm.markAllAsTouched();
			return;
		}

		this.loading.set(true);
		this.errorMessage.set(null);
		this.accessDataChange.emit({ email: this.accessForm.value.email });
		this.submitRegister.emit();
	}

	setLoading(value: boolean): void {
		this.loading.set(value);
	}

	setError(message: string): void {
		this.loading.set(false);
		this.errorMessage.set(message);
	}

	openTerminos(): void {
		window.open('https://firebasestorage.googleapis.com/v0/b/os-arg-vicente-lopez.appspot.com/o/brand%2FPROYECTO_TyCIDENTIDAD_DIGITAL_.pdf?alt=media&token=75d7c3b9-bc5a-4afe-b044-11c2c23cebe8', '_blank');
	}

	openPoliticas(): void {
		window.open('https://firebasestorage.googleapis.com/v0/b/os-arg-vicente-lopez.appspot.com/o/brand%2FPROYECTO_TyCIDENTIDAD_DIGITAL_.pdf?alt=media&token=75d7c3b9-bc5a-4afe-b044-11c2c23cebe8', '_blank');
	}
}
